module.exports = __webpack_public_path__ + "static/4-cb1047db169e721a5211c18520e073e6.jpg";